<template>
  <div @click="handleCTAClick()">
    <div
      v-if="dataBannerImg || dataImgBg"
      :class="dataBannerImgStyle"
      :style="getBannerStyle"
    >
      <img :src="dataBannerImg || dataImgBg" :style="getImageStyle" />
    </div>
    <div class="card-content" v-if="!dataImgBg">
      <div
        class="pr flex-column hero-banner-content"
        :style="{ textAlign: dataTextAlign }"
      >
        <p class="hero-title" :style="getTitleStyle">{{ dataTitle }}</p>
        <p class="hero-description" :style="getSubtitleStyle">
          {{ dataSubTitle }}
        </p>
        <button
          class="hero-action"
          :style="getDataActionStyle"
          @click="handleCTAClick()"
        >
          {{ dataCtaText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  EVENT_IMPRESSION_PROMOTION,
  EVENT_CLICK_PROMOTION,
} from "../helpers/analyticsEvents";
import localStorageFunc from "../helpers/localStorageFunc";
import Utility from "../helpers/utility";
import { projectBasePathWithFolder } from "../config/apiEndpoints";
export default {
  name: "HeroBanners",
  props: [
    "dataTitle",
    "dataSubTitle",
    "dataCtaText",
    "dataBannerImg",
    "dataImgBg",
    "dataJustifyImgContent",
    "dataTitleColor",
    "dataSubTitleColor",
    "dataActionButtonColor",
    "dataActionButtonBackground",
    "dataTextAlign",
    "dataImgOpacity",
    "dataBannerImgStyle",
    "dataAction",
    "dataCoupon",
    "dataImgLeft",
    "dataImgWidth",
    "dataImgHeight",
    "dataBannerBorderRadius",
  ],
  mounted() {
    EVENT_IMPRESSION_PROMOTION({
      ecommerce: {
        promotions: [
          {
            promotion_id: "",
            promotion_name: this.dataSubTitle,
            creative_name: "",
            creative_slot: "top",
          },
        ],
      },
    });
  },
  computed: {
    getBannerStyle() {
      return {
        justifyContent: this.dataJustifyImgContent,
        left: this.dataImgLeft,
      };
    },
    getImageStyle() {
      return {
        opacity: this.dataImgOpacity,
        width: this.dataImgWidth || "100%",
        height: this.dataImgHeight || "154px",
        borderRadius: this.dataBannerBorderRadius || "12px",
      };
    },
    getTitleStyle() {
      return { color: this.dataTitleColor };
    },
    getSubtitleStyle() {
      return { color: this.dataSubTitleColor };
    },
    getDataActionStyle() {
      return {
        color: this.dataActionButtonColor,
        background: this.dataActionButtonBackground,
      };
    },
  },
  methods: {
    handleCTAClick() {
      if (this.dataAction.includes("/offers")) {
        // Utility.sendToOffersScreen();
        const redirectUrl = this.dataAction + "?offerId=" + this.dataCoupon;
        Utility.redirectToLinkRewrite(redirectUrl);
      } else if (this.dataAction.includes("catId")) {
        this.goto(this.dataAction.replace("catId=", ""));
      } else if (this.dataAction.includes("prod_id")) {
        Utility.gotoElement({
          type: "PRODUCT",
          id: this.dataAction.replace("prod_id=", ""),
        });
      } else if (this.dataAction.includes("/menu")) {
        Utility.sendToMenuScreen();
      }
      EVENT_CLICK_PROMOTION({
        ecommerce: {
          promotions: [
            {
              promotion_id: "",
              promotion_name: this.dataSubTitle,
              creative_name: "",
              creative_slot: "top",
            },
          ],
        },
      });
    },
    goto(item) {
      let url =
        projectBasePathWithFolder +
        "/menu/" +
        localStorageFunc.storeId() +
        Utility.getUrlQueryString();
      url = this.scrollToCategoryId(item, url);
      window.location.href = url;
    },
    scrollToCategoryId(item, url) {
      if (item) {
        const categoryId = item;
        url = Utility.addUpdateParam(url, "showSearchModal", false);
        return Utility.addUpdateParam(url, "scrollTo", categoryId);
      }
      return url;
    },
  },
};
</script>

<style></style>
